import { render, staticRenderFns } from "./filtration.vue?vue&type=template&id=0b6feb9c&scoped=true&"
import script from "./filtration.vue?vue&type=script&lang=js&"
export * from "./filtration.vue?vue&type=script&lang=js&"
import style0 from "./filtration.vue?vue&type=style&index=0&id=0b6feb9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6feb9c",
  null
  
)

export default component.exports